import { render, staticRenderFns } from "./AppointmentTable.vue?vue&type=template&id=6daeaa6b&scoped=true"
import script from "./AppointmentTable.vue?vue&type=script&lang=js"
export * from "./AppointmentTable.vue?vue&type=script&lang=js"
import style0 from "./AppointmentTable.vue?vue&type=style&index=0&id=6daeaa6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daeaa6b",
  null
  
)

export default component.exports